import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { PAGINATION_META_KEY } from '@/app/core/http/pagination';

type ApiEnvelope<T> = {
  success: true;
  data: T;
  meta?: unknown;
}

function isApiEnvelope(body: unknown): body is ApiEnvelope<unknown> {
  return !!body && typeof body === 'object' && 'success' in body && 'data' in body;
}

/**
 * Backend wraps every successful response as {success, data, meta?}.
 * Unwrapping here once means every existing `http.get&lt;T>()` call site keeps
 * working unchanged — only the paginated endpoints need `meta`, which is
 * attached as a hidden property on the unwrapped array for `getPaginated()`
 * to pick up.
 */
export const apiEnvelopeInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map((event) => {
      if (!(event instanceof HttpResponse) || !isApiEnvelope(event.body)) {
        return event;
      }

      const { data, meta } = event.body;
      if (meta && data && typeof data === 'object') {
        (data as Record<string, unknown>)[PAGINATION_META_KEY] = meta;
      }

      return event.clone({ body: data });
    })
  );
